import { css } from '@emotion/css';

export const inputStyle = css`
  input {
    width: 100% !important;
  }
`;

export const shortTextStyle = css`
  width: 46.4rem !important;
`;

export const longTextStyle = css`
  width: 46.4rem !important;
  height: 15.8rem !important;
`;

export const actionButtonInFocus = css`
  width: 44.8rem; // max-w-448
`;
